import { render } from "./PartsHeader.vue?vue&type=template&id=a7e098b6&scoped=true"
import script from "./PartsHeader.vue?vue&type=script&lang=js"
export * from "./PartsHeader.vue?vue&type=script&lang=js"

import "./PartsHeader.vue?vue&type=style&index=0&id=a7e098b6&scoped=true&lang=css"

import exportComponent from "/Users/maru/Desktop/東野材木/hojokin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7e098b6"]])

export default __exports__